/* ============================================================
   SignageWorks — 2027 Budget Planner
   ============================================================
   Four steps: property -> what you have -> how many -> the reveal.

   Pricing rule (Dean, 2026-08-28): full transparency, but NOTHING is
   priced until steps 1-3 are complete. The number is the payoff for
   finishing, not the bait — which is why the timing and notes fields
   sit at the end of step 3 rather than after the reveal.

   Quantity rule: customers enter their own counts. There is no derived
   math anywhere in this file — no "one per building".

   The instant figure is a WORKING BUDGET RANGE, not a quote. The formal
   estimate follows within 24 hours and holds for 12 months.

   This catalog mirrors backend/src/lib/budget-catalog.js, which is the
   authority — the server recalculates every submission and ignores the
   number computed here. If prices change, change them in both places.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-sw-planner]');
  if (!root) return;

  var ENDPOINT = root.getAttribute('data-endpoint') || '/api/budget-request';

  var CATALOG = [
    { g:'monument',  k:'mon96',   n:'Monument Face Replacement',         s:'48" x 96"',   mb:null, sv:695 },
    { g:'monument',  k:'mon48',   n:'Monument Face Replacement',         s:'38" x 48"',   mb:null, sv:395 },
    { g:'leasing',   k:'lowall',  n:'Leasing Office — For Wall',         s:'18" x 24"',   mb:135, sv:95 },
    { g:'leasing',   k:'lopost',  n:'Leasing Office — For Post',         s:'24" x 36"',   mb:255, sv:235 },
    { g:'leasing',   k:'lodir',   n:'Leasing Office Directional',        s:'18" x 24"',   mb:135, sv:95 },
    { g:'leasing',   k:'maint',   n:'Maintenance Room',                  s:'18" x 24"',   mb:135, sv:95 },
    { g:'buildings', k:'bldadr',  n:'Building Address',                  s:'18" x 24"',   mb:135, sv:95 },
    { g:'buildings', k:'blddir',  n:'Building Directional',              s:'24" x 36"',   mb:255, sv:235 },
    { g:'buildings', k:'unit',    n:'Unit Numbers',                      s:'4" x 9"',     mb:28,  sv:20 },
    { g:'parking',   k:'future',  n:'Future Resident Parking',           s:'18" x 24"',   mb:135, sv:95 },
    { g:'parking',   k:'nopark',  n:'No Parking Anytime',                s:'12" x 18"',   mb:95,  sv:75 },
    { g:'pool',      k:'poolr',   n:'Pool Rules',                        s:'24" x 36"',   mb:255, sv:235 },
    { g:'pool',      k:'nolife',  n:'No Lifeguard On Duty',              s:'48" x 36.5"', mb:null, sv:222 },
    { g:'pool',      k:'shallow', n:'Shallow Water / No Diving',         s:'48" x 36.5"', mb:null, sv:222 },
    { g:'fitness',   k:'fit',     n:'Fitness Center',                    s:'8" x 36"',    mb:85,  sv:75 },
    { g:'fitness',   k:'fitr',    n:'Fitness Center Rules',              s:'18" x 24"',   mb:135, sv:95 },
    { g:'laundry',   k:'laun',    n:'Laundry Room',                      s:'8" x 36"',    mb:85,  sv:75 },
    { g:'mail',      k:'mail',    n:'Mail Center',                       s:'8" x 36"',    mb:85,  sv:75 },
    { g:'dogpark',   k:'dog',     n:'Dog Park Rules',                    s:'18" x 24"',   mb:135, sv:95 },
    { g:'play',      k:'playr',   n:'Play Area Rules',                   s:'18" x 24"',   mb:135, sv:95 },
    { g:'play',      k:'playd',   n:'Play Area Directional',             s:'18" x 24"',   mb:135, sv:95 },
    { g:'grill',     k:'grill',   n:'Grilling & Picnic Area',            s:'18" x 24"',   mb:135, sv:95 },
    { g:'firepit',   k:'fire',    n:'Fire Pit Rules',                    s:'24" x 36"',   mb:255, sv:235 },
    { g:'carcare',   k:'car',     n:'Car Care Center',                   s:'24" x 36"',   mb:255, sv:235 },
    { g:'dumpster',  k:'dump',    n:'Dumpster Rules',                    s:'24" x 36"',   mb:255, sv:235 },
    { g:'pond',      k:'fish',    n:'No Fishing',                        s:'18" x 24"',   mb:135, sv:95 },
    { g:'security',  k:'priv24',  n:'Private Property / No Trespassing', s:'18" x 24"',   mb:135, sv:95 },
    { g:'security',  k:'priv18',  n:'Private Property / No Trespassing', s:'12" x 18"',   mb:95,  sv:75 }
  ];

  var GROUPS = [
    { g:'monument',  label:'Monument sign',     icon:'swi-pricehold' },
    { g:'leasing',   label:'Leasing office',    icon:'swi-visualize' },
    { g:'buildings', label:'Buildings & units', icon:'swi-visualize' },
    { g:'parking',   label:'Parking',           icon:'swi-order' },
    { g:'pool',      label:'Pool',              icon:'swi-quality' },
    { g:'fitness',   label:'Fitness center',    icon:'swi-fast' },
    { g:'laundry',   label:'Laundry',           icon:'swi-logos' },
    { g:'mail',      label:'Mail center',       icon:'swi-shipping' },
    { g:'dogpark',   label:'Dog park',          icon:'swi-check' },
    { g:'play',      label:'Playground',        icon:'swi-check' },
    { g:'grill',     label:'Grilling area',     icon:'swi-check' },
    { g:'firepit',   label:'Fire pit',          icon:'swi-check' },
    { g:'carcare',   label:'Car care center',   icon:'swi-order' },
    { g:'dumpster',  label:'Dumpsters',         icon:'swi-check' },
    { g:'pond',      label:'Pond / lake',       icon:'swi-check' },
    { g:'security',  label:'Property signage',  icon:'swi-noobligation' }
  ];

  var picked = {};
  var qty = {};
  var finish = 'mb';
  var lastRange = { low: 0, high: 0 };
  var submitting = false;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var money = function (n) { return '$' + Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 0 }); };

  function track(event, payload) {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track) {
        window.ShopifyAnalytics.lib.track(event, payload || {}); return;
      }
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: event }, payload || {})); return;
      }
    } catch (e) { /* analytics must never break the page */ }
    if (window.console && console.debug) console.debug('[sw-planner]', event, payload || {});
  }

  /* ---------- attribution, carried from the landing page ---------- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { out[k] = v; try { sessionStorage.setItem('sw_' + k, v); } catch (e) {} }
      else { try { var s = sessionStorage.getItem('sw_' + k); if (s) out[k] = s; } catch (e) {} }
    });
    out.landing_url = window.location.href.slice(0, 500);
    out.referring_url = (document.referrer || '').slice(0, 500);
    return out;
  }

  function icon(id, cls) {
    return '<svg class="sw-i ' + (cls || '') + '" aria-hidden="true"><use href="#' + id + '"></use></svg>';
  }

  /* ---------- step 2: what the property has ---------- */
  var tilesEl = $('[data-tiles]');
  var cont2 = $('[data-continue-2]');

  GROUPS.forEach(function (grp) {
    var b = document.createElement('button');
    b.className = 'sw-bp__tile';
    b.type = 'button';
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<span class="sw-bp__tileDot"></span><span>' + grp.label + '</span>';
    b.addEventListener('click', function () {
      picked[grp.g] = !picked[grp.g];
      b.classList.toggle('is-sel', !!picked[grp.g]);
      b.setAttribute('aria-pressed', picked[grp.g] ? 'true' : 'false');
      cont2.disabled = !anyPicked();
    });
    tilesEl.appendChild(b);
  });
  cont2.disabled = true;

  function anyPicked() {
    for (var k in picked) { if (picked[k]) return true; }
    return false;
  }

  /* ---------- step 3: how many ---------- */
  function buildQuantities() {
    var host = $('[data-quantities]');
    host.innerHTML = '';

    GROUPS.filter(function (g) { return picked[g.g]; }).forEach(function (grp) {
      var wrap = document.createElement('div');
      wrap.className = 'sw-bp__qgroup';

      var h = document.createElement('h3');
      h.textContent = grp.label;
      wrap.appendChild(h);

      CATALOG.filter(function (c) { return c.g === grp.g; }).forEach(function (c) {
        if (qty[c.k] === undefined) qty[c.k] = 0;

        var row = document.createElement('div');
        row.className = 'sw-bp__qrow';
        row.innerHTML =
          '<div class="sw-bp__qinfo"><div class="sw-bp__qname"></div><div class="sw-bp__qsize"></div></div>' +
          '<div class="sw-bp__stepper">' +
            '<button type="button" aria-label="Fewer">&minus;</button>' +
            '<input type="number" min="0" inputmode="numeric">' +
            '<button type="button" aria-label="More">+</button>' +
          '</div>';

        row.querySelector('.sw-bp__qname').textContent = c.n;
        row.querySelector('.sw-bp__qsize').textContent = c.s;

        var btns = row.querySelectorAll('.sw-bp__stepper button');
        var inp = row.querySelector('.sw-bp__stepper input');
        inp.value = qty[c.k];
        inp.setAttribute('aria-label', c.n + ' ' + c.s + ' quantity');

        btns[0].addEventListener('click', function () {
          inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) - 1);
          qty[c.k] = parseInt(inp.value, 10);
        });
        btns[1].addEventListener('click', function () {
          inp.value = (parseInt(inp.value, 10) || 0) + 1;
          qty[c.k] = parseInt(inp.value, 10);
        });
        inp.addEventListener('input', function () {
          qty[c.k] = Math.max(0, parseInt(inp.value, 10) || 0);
        });

        wrap.appendChild(row);
      });

      host.appendChild(wrap);
    });

  }

  /* ---------- step 4: the reveal ---------- */
  $$('[data-finish]').forEach(function (b) {
    b.addEventListener('click', function () {
      finish = b.getAttribute('data-finish');
      $$('[data-finish]').forEach(function (x) {
        x.classList.toggle('is-sel', x.getAttribute('data-finish') === finish);
      });
      calc();
    });
  });

  function unit(item, f) {
    if (f === 'sv') return item.sv;
    return item.mb === null ? item.sv : item.mb;   // acrylic falls back where it doesn't exist
  }

  function calc() {
    var mbTotal = 0, svTotal = 0, count = 0;
    var rows = [];

    CATALOG.forEach(function (c) {
      var n = qty[c.k] || 0;
      if (!n || !picked[c.g]) return;
      count += n;
      mbTotal += n * unit(c, 'mb');
      svTotal += n * unit(c, 'sv');
      rows.push({ c: c, q: n });
    });

    var lines = $('[data-lines]');
    lines.innerHTML = '';

    rows.forEach(function (r) {
      var u = unit(r.c, finish === 'sv' ? 'sv' : 'mb');
      var el = document.createElement('div');
      el.className = 'sw-bp__sline';
      var left = document.createElement('span');
      left.textContent = r.c.n + ' ';
      var size = document.createElement('span');
      size.className = 'q';
      size.textContent = '· ' + r.c.s;
      left.appendChild(size);
      var right = document.createElement('span');
      right.className = 'q';
      right.textContent = r.q + ' × ' + money(u);
      el.appendChild(left); el.appendChild(right);
      lines.appendChild(el);
    });

    if (!rows.length) {
      lines.innerHTML = '<div class="sw-bp__sline"><span style="color:#94a3b8">' +
        'Nothing counted yet — go back a step and add a few.</span></div>';
    }

    var lo, hi, label;
    if (finish === 'sv')      { lo = svTotal; hi = svTotal; label = 'Summit View'; }
    else if (finish === 'mb') { lo = mbTotal; hi = mbTotal; label = 'Metro Beach'; }
    else { lo = Math.min(mbTotal, svTotal); hi = Math.max(mbTotal, svTotal); label = 'Both finishes'; }

    var rlo = Math.round(lo * 0.95 / 10) * 10;
    var rhi = Math.round(hi * 1.05 / 10) * 10;
    lastRange = { low: rlo, high: rhi };

    $('[data-range]').textContent = count === 0 ? '$0'
      : (rlo === rhi ? money(rlo) : money(rlo) + ' – ' + money(rhi));

    var meta = $('[data-meta]');
    meta.innerHTML = '';
    var b = document.createElement('b');
    b.textContent = String(count);
    meta.appendChild(b);
    meta.appendChild(document.createTextNode(' sign' + (count === 1 ? '' : 's') + ' · ' + label));
    if (rows.length) {
      var t = document.createElement('div');
      t.className = 'sw-bp__sline sw-bp__sline--total';
      t.innerHTML = '<span>Estimated total</span><span>' +
        (rlo === rhi ? money(rlo) : money(rlo) + ' – ' + money(rhi)) + '</span>';
      lines.appendChild(t);
    }
  }

  /* ---------- navigation ---------- */
  function go(n) {
    if (n === 2 && !validateStep1()) return;
    if (n === 4 && !validateNeedBy()) return;
    if (n === 3) buildQuantities();
    if (n === 4) { calc(); track('budget_result_viewed', { total: lastRange.high }); }

    $$('.sw-bp__panel').forEach(function (p) { p.classList.remove('is-active'); });
    $('[data-panel="' + n + '"]').classList.add('is-active');

    $$('.sw-bp__railStep').forEach(function (s) {
      var i = parseInt(s.getAttribute('data-rail'), 10);
      s.classList.toggle('is-active', i === n);
      s.classList.toggle('is-done', i < n);
    });

    var rail = root.querySelector('.sw-bp__rail');
    if (rail) rail.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('planner_step_completed', { step: n });
  }

  $$('[data-go]').forEach(function (b) {
    b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-go'), 10)); });
  });

  function validateStep1() {
    var required = ['#bp_prop', '#bp_name', '#bp_email'];
    var ok = true, firstBad = null;
    required.forEach(function (sel) {
      var el = $(sel);
      var bad = !el.value.trim();
      if (sel === '#bp_email' && el.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) bad = true;
      el.classList.toggle('is-invalid', bad);
      if (bad) { ok = false; if (!firstBad) firstBad = el; }
    });
    if (firstBad) { firstBad.focus(); track('form_error', { form: 'planner_step1' }); }
    return ok;
  }

  function validateNeedBy() {
    var el = $('#bp_when');
    if (!el) return true;
    var v = (el.value || '').trim();
    var ok = /^\d{4}-\d{2}-\d{2}$/.test(v);
    if (ok) {
      var d = new Date(v + 'T00:00:00Z');
      ok = !isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v;
    }
    el.classList.toggle('is-invalid', !ok);
    if (!ok) { el.focus(); track('form_error', { form: 'planner_need_by' }); }
    return ok;
  }

  /* ---------- submit ---------- */
  var submitBtn = $('[data-submit]');
  var errBox = $('[data-error]');

  submitBtn.addEventListener('click', function () {
    if (submitting) return;

    var quantities = {};
    CATALOG.forEach(function (c) {
      var n = qty[c.k] || 0;
      if (n > 0 && picked[c.g]) quantities[c.k] = n;
    });

    var hp = $('#bp_website');
    var payload = Object.assign({
      property_name:    $('#bp_prop').value.trim(),
      property_address: $('#bp_addr').value.trim(),
      management:       $('#bp_mgmt').value.trim(),
      contact_name:     $('#bp_name').value.trim(),
      email:            $('#bp_email').value.trim(),
      phone:            $('#bp_phone').value.trim(),
      finish:           finish,
      need_by_date:     $('#bp_when').value,
      notes:            $('#bp_notes').value.trim(),
      budget_shown:     lastRange.high,
      quantities:       quantities,
      source:           'Website',
      company_website:  hp ? hp.value : ''
    }, attribution());

    errBox.classList.remove('is-shown');
    submitting = true;
    submitBtn.disabled = true;
    var original = submitBtn.textContent;
    submitBtn.textContent = 'Sending…';
    track('formal_estimate_requested', { total: lastRange.high, signs: payload.quantities });

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; })
          .then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (r) {
        if (!r.ok || !r.body.ok) {
          throw new Error((r.body && (r.body.error || (r.body.errors || []).join(', '))) || 'Request failed');
        }
        $$('.sw-bp__panel').forEach(function (p) { p.classList.remove('is-active'); });
        $('[data-panel="5"]').classList.add('is-active');
        $$('.sw-bp__railStep').forEach(function (s) { s.classList.add('is-done'); s.classList.remove('is-active'); });
        var rail = root.querySelector('.sw-bp__rail');
        if (rail) rail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        if (window.console) console.error('[sw-planner]', err);
        errBox.textContent = "We couldn't send that just now. Please try again, or email hello@signageworks.com and we'll take it down for you.";
        errBox.classList.add('is-shown');
        submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        track('form_error', { form: 'planner_submit' });
      });
  });

  track('planner_started', {});
})();
